// src/services/WorkPlanService.js

import axios from '../utils/axios';

const WorkPlanService = {
    
    // Get active/all work plans
    getActiveWorkPlans: async (filters = {}) => {
        const params = new URLSearchParams();
        if (filters.region) params.append('region', filters.region);
        if (filters.status) params.append('status', filters.status);
        if (filters.date_from) params.append('date_from', filters.date_from);
        if (filters.date_to) params.append('date_to', filters.date_to);
        
        const url = params.toString() ? `workPlans?${params}` : 'workPlans';
        const response = await axios.get(url);
        return response.data;
    },

    // Get single work plan
    getWorkPlan: async (id) => {
        const response = await axios.get(`workPlans/${id}`);
        return response.data;
    },

    // Create work plan
    createWorkPlan: async (data) => {
        const response = await axios.post('workPlans', data);
        return response.data;
    },

    // Update work plan
    updateWorkPlan: async (id, data) => {
        const response = await axios.put(`workPlans/${id}`, data);
        return response.data;
    },

    // Delete work plan
    deleteWorkPlan: async (id) => {
        const response = await axios.delete(`workPlans/${id}`);
        return response.data;
    },

    // Get work plan metrics
    getMetrics: async (id) => {
        const response = await axios.get(`workPlans/${id}/metrics`);
        return response.data;
    },

    // Get scheduled visits
    getScheduledVisits: async (filters = {}) => {
        const params = new URLSearchParams();
        if (filters.work_plan_ids) params.append('work_plan_ids', filters.work_plan_ids);
        if (filters.region) params.append('region', filters.region);
        if (filters.status) params.append('status', filters.status);
        if (filters.include_team) params.append('include_team', filters.include_team);
        
        const url = params.toString() ? `scheduledVisits?${params}` : 'scheduledVisits';
        const response = await axios.get(url);
        return response.data;
    },

    // Schedule visit
    scheduleVisit: async (data) => {
        const response = await axios.post('scheduledVisits', data);
        return response.data;
    },

    // Delete visit
    deleteVisit: async (id) => {
        const response = await axios.delete(`scheduledVisits/${id}`);
        return response.data;
    },

    // Get visit statistics
    getVisitStatistics: async (filters = {}) => {
        const params = new URLSearchParams();
        if (filters.region) params.append('region', filters.region);
        if (filters.date_from) params.append('date_from', filters.date_from);
        if (filters.date_to) params.append('date_to', filters.date_to);
        
        const url = params.toString() ? `visitStatistics?${params}` : 'visitStatistics';
        const response = await axios.get(url);
        return response.data;
    },

    // Get available users
    getAvailableUsers: async () => {
        const response = await axios.get('users?status=1');
        return response.data;
    },

    // Assign team member
    assignTeamMember: async (visitId, data) => {
        const response = await axios.post(`scheduledVisits/${visitId}/team`, data);
        return response.data;
    },

    // Remove team member
    removeTeamMember: async (visitId, userId) => {
        const response = await axios.delete(`scheduledVisits/${visitId}/team/${userId}`);
        return response.data;
    },

    // Update team member role
    updateTeamMemberRole: async (visitId, userId, role) => {
        const response = await axios.put(`scheduledVisits/${visitId}/team/${userId}`, { role });
        return response.data;
    },

    // Get team assignments
    getTeamAssignments: async (visitId) => {
        const response = await axios.get(`scheduledVisits/${visitId}/team`);
        return response.data;
    },
    updateVisitStatus: async (visitId, data) => {
    return axios.put(`scheduledVisits/${visitId}/status`, data);
},

canUpdateStatus: async (visitId) => {
    return axios.get(`scheduledVisits/${visitId}/canUpdateStatus`);
}
};

export default WorkPlanService;